import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { CellContext } from '@tanstack/react-table';
import { FormattedMessage, useIntl } from 'react-intl';

import { Button } from 'src/registry/ui/Button';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from 'src/registry/ui/Tooltip';
import { generalMessages } from 'src/registry/utils/messages';
import { ICON_MAP } from 'src/utils/constants';
import { MembershipIdentifier } from 'src/features/membership/types';
import UpdateIdentifierFormModal from 'src/features/membership/components/forms/identifier/UpdateIdentifierFormModal';
import { identifiersMessages } from 'src/features/membership/utils/messages';
import DeleteIdentifierFormModal from 'src/features/membership/components/forms/identifier/DeleteIdentifierFormModal';

export default function CellIdentifierActions({ row }: CellContext<MembershipIdentifier, unknown>) {
    const { formatMessage } = useIntl();

    return (
        <div className="flex gap-1">
            <TooltipProvider>
                <Tooltip>
                    <UpdateIdentifierFormModal
                        selectedIdentifier={row.original}
                        semantics={{ entryName: formatMessage(identifiersMessages.identifier) }}
                    >
                        <TooltipTrigger asChild>
                            <Button size="icon" variant="link" className="cursor-pointer hover:bg-gray-100">
                                <FontAwesomeIcon icon={ICON_MAP.EDIT} />
                            </Button>
                        </TooltipTrigger>
                    </UpdateIdentifierFormModal>
                    <TooltipContent>
                        <FormattedMessage {...generalMessages.edit} />
                    </TooltipContent>
                </Tooltip>

                <Tooltip>
                    <DeleteIdentifierFormModal
                        selectedIdentifier={row.original}
                        semantics={{ entryName: formatMessage(identifiersMessages.identifier) }}
                    >
                        <TooltipTrigger asChild>
                            <Button size="icon" variant="link" className="cursor-pointer hover:bg-gray-100">
                                <FontAwesomeIcon icon={ICON_MAP.DELETE} />
                            </Button>
                        </TooltipTrigger>
                    </DeleteIdentifierFormModal>
                    <TooltipContent>
                        <FormattedMessage {...generalMessages.delete} />
                    </TooltipContent>
                </Tooltip>
            </TooltipProvider>
        </div>
    );
}
